<template>
  <vs-row vs-type="flex">
    <vs-col
      vs-order="1"
      vs-type="flex"
      vs-justify="start"
      vs-align="center"
      vs-w="4"
      class="aisea-text-14-400-white"
    >
      初期表示位置
    </vs-col>
    <vs-col
      vs-order="2"
      vs-type="flex"
      vs-justify="flex-end"
      vs-align="center"
      vs-w="8"
    >
      <vx-tooltip :color="AISEA_COLOR.GRAY_BLACK" :text="tooltipText" position="top">
        <vs-button
          class="ml-4 mt-4 mb-4 aisea-text-14-400-white"
          :color="AISEA_COLOR.BLUE"
          type="filled"
          @click="onSaveMapCoordinateAndZoom"
          >現在地を設定</vs-button
        >
      </vx-tooltip>
    </vs-col>
  </vs-row>
</template>

<script>
import {createNamespacedHelpers} from "vuex";
import LocalDbService from "@/services/localDbService";
import FireStoreService from "@/services/fireStoreService";

// Mixins
import {ColorMixin} from "@/mixins";

// Store
const {
  mapGetters: mapGettersOfMapSetting
} = createNamespacedHelpers("mapSetting");

export default {
  mixins: [ColorMixin],
  components: {},
  data() {
    return {
      tooltipText:
        "現在表示中の緯度経度、ズーム値を初期表示地点として保存します",
      icon: require("@/assets/images/icons/sideber-menu/search.svg")
    };
  },
  computed: {
    ...mapGettersOfMapSetting(["getCenter", "getZoom"]),
  },
  mounted() {},
  watch: {},
  methods: {
    async onSaveMapCoordinateAndZoom() {
      let center = this.getCenter
      let defaultPosition = {
        center: [center.lng, center.lat],
        zoom: this.getZoom
      }
      await FireStoreService.saveDefaultPosition(defaultPosition)
      await LocalDbService.saveDefaultPosition(defaultPosition);
      this.$vs.notify({
        title: "初期表示の設定",
        text: "現在の状態を初期表示地点として保存しました",
        color: "success",
        position: "top-center",
      });
    }
  }
};
</script>

<style lang="sass"></style>
